/* fail-safe */try{
(function () {
/* Engagement time: assigned content AND, since 2026-08-29, general library
 * use for signed-in members.
 *
 * Two modes, one pipeline:
 *   ?a=<assignment> in the URL  -> rows tagged with that assignment; these
 *       are the ONLY rows AD-facing surfaces ever read.
 *   signed-in member on a post  -> rows tagged assignment='' — internal
 *       Proactive Coaching analytics, disclosed in the privacy policy
 *       ("Member activity" section). Never shown to schools/program leads:
 *       the worker's AD queries all filter assignment != ''.
 * Not signed in and no assignment param: nothing runs, nothing is sent.
 *
 * Measures three kinds on this page, batched to one flush:
 *   read   — seconds the tab is visible AND the reader was recently active
 *   listen — real played seconds from any <audio> (narration, podcasts)
 *   watch  — seconds + furthest % from the Vimeo player's own messages
 *
 * Transport rules (from the build review + the 2026-08-20 audit): milestone/
 * interval flushes with a WARM member token (10-min expiry, refreshed every
 * 4 min), fetch keepalive on pagehide with the token in the body because
 * sendBeacon can't set headers. A failed interval flush RESTORES its seconds
 * so a dead token or a network blip never destroys measured time. Vimeo
 * subscriptions retry on iframe load + 600/1800ms (the player's script races
 * ours — the proven pattern from page-videos.hbs). Additive only: subscribes
 * to Vimeo postMessages itself, touches none of the page's existing player
 * code. ES5 for old Safari, isolated script.
 */
var API = 'https://member-api.proactivecoaching.ai';
var qs = /[?&]a=([^&]+)/.exec(location.search);
var ASSIGNMENT = '';
if (qs) { try { ASSIGNMENT = decodeURIComponent(qs[1]).slice(0, 120); } catch (e) { ASSIGNMENT = qs[1].slice(0, 120); } }
/* general tracking: signed-in member (body flag from default.hbs) on a post
   page — content pieces only, never browsing chrome like /library/ */
var GENERAL = !ASSIGNMENT &&
    document.body.getAttribute('data-pc-member') === '1' &&
    document.body.className.indexOf('post-template') > -1;
if (ASSIGNMENT || GENERAL) {
    var PATHKEY = location.pathname;
    var acc = { read: 0, listen: 0, watch: 0 };
    var pct = { listen: 0, watch: 0 };
    /* highest pct already stored server-side, so idle tabs stop re-posting it */
    var sentPct = { listen: 0, watch: 0 };
    var lastActive = Date.now();
    var lastTick = Date.now();

    ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'].forEach(function (ev) {
        window.addEventListener(ev, function () { lastActive = Date.now(); }, { passive: true });
    });
    setInterval(function () {
        var now = Date.now();
        if (!document.hidden && now - lastActive < 30000) acc.read += Math.min(5, (now - lastTick) / 1000);
        lastTick = now;
    }, 5000);

    /* listen: delta-accumulate real playback from every audio element */
    function hookAudio(au) {
        if (au.__pcEng) return; au.__pcEng = 1;
        var last = null;
        au.addEventListener('timeupdate', function () {
            var t = au.currentTime;
            if (last !== null && t > last && t - last < 2.5) acc.listen += (t - last);
            last = t;
            if (au.duration) pct.listen = Math.max(pct.listen, Math.round(t * 100 / au.duration));
        });
        au.addEventListener('seeking', function () { last = null; });
    }
    function scanAudio() {
        var els = document.getElementsByTagName('audio');
        for (var i = 0; i < els.length; i++) hookAudio(els[i]);
    }
    scanAudio(); setInterval(scanAudio, 3000);

    /* watch: subscribe to Vimeo player events ourselves (additive). The
       subscription message races the player's own script load — send it on
       the iframe's load event and again at 600/1800ms (duplicate
       subscriptions are harmless: the delta tracker ignores repeated equal
       positions). Guard is per-iframe WIRING, not per-attempt. */
    function subOne(f) {
        try {
            ['playProgress', 'timeupdate'].forEach(function (ev) {
                f.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: ev }), 'https://player.vimeo.com');
            });
        } catch (e) {}
    }
    function subVimeo() {
        var ifr = document.querySelectorAll('iframe[src*="player.vimeo.com"]');
        for (var i = 0; i < ifr.length; i++) {
            (function (f) {
                if (f.__pcEng) { subOne(f); return; } /* re-ask each sweep; idempotent */
                f.__pcEng = 1;
                subOne(f);
                f.addEventListener('load', function () {
                    subOne(f);
                    setTimeout(function () { subOne(f); }, 600);
                    setTimeout(function () { subOne(f); }, 1800);
                });
                setTimeout(function () { subOne(f); }, 600);
                setTimeout(function () { subOne(f); }, 1800);
            })(ifr[i]);
        }
    }
    /* per-player position tracking, so two players never interleave deltas */
    var vidTrack = [];
    function trackFor(src) {
        for (var i = 0; i < vidTrack.length; i++) if (vidTrack[i].w === src) return vidTrack[i];
        var t = { w: src, last: null };
        vidTrack.push(t);
        return t;
    }
    window.addEventListener('message', function (e) {
        if (e.origin !== 'https://player.vimeo.com') return;
        var d = e.data;
        try { if (typeof d === 'string') d = JSON.parse(d); } catch (err) { return; }
        var p = d && d.data;
        if (!p) return;
        var secs = p.seconds, dur = p.duration;
        if (typeof secs === 'number') {
            var tr = trackFor(e.source);
            if (tr.last !== null && secs > tr.last && secs - tr.last < 2.5) acc.watch += (secs - tr.last);
            tr.last = secs;
            if (dur) pct.watch = Math.max(pct.watch, Math.round(secs * 100 / dur));
            if (typeof p.percent === 'number') pct.watch = Math.max(pct.watch, Math.round(p.percent * 100));
        }
    });
    subVimeo(); setInterval(subVimeo, 3000);

    function events() {
        var out = [];
        ['read', 'listen', 'watch'].forEach(function (k) {
            var s = Math.round(acc[k]);
            var mp = k === 'read' ? 0 : (pct[k] || 0);
            /* emit only when there are new seconds or a new furthest point —
               an idle open tab must not chatter zero-second beacons forever */
            if (s > 0 || (mp > 0 && mp > (sentPct[k] || 0))) out.push({ path: PATHKEY, kind: k, seconds: s, maxPct: mp, assignment: ASSIGNMENT });
        });
        return out;
    }
    function reset() { acc = { read: 0, listen: 0, watch: 0 }; }
    function restore(evs) {
        /* a failed interval flush must not destroy measured time */
        for (var i = 0; i < evs.length; i++) acc[evs[i].kind] += (evs[i].seconds || 0);
    }
    function markSent(evs) {
        for (var i = 0; i < evs.length; i++) {
            var k = evs[i].kind;
            if (evs[i].maxPct > (sentPct[k] || 0)) sentPct[k] = evs[i].maxPct;
        }
    }

    /* A pagehide flush has no time for an async token fetch — the page is
       already dying, so the .then never runs and the beacon is silently
       lost (exactly the watched-the-whole-video-counted-as-nothing bug).
       Keep a token WARM instead: refreshed on load and every 4 minutes
       (they live 10), so the final flush can POST synchronously. */
    var tok = '';
    function warmToken() {
        fetch('/members/api/session', { credentials: 'include' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (t) { if (t) tok = t; })
            .catch(function () {});
    }
    warmToken();
    setInterval(warmToken, 240000);

    function post(evs, final) {
        /* Response handling is UNIFORM for interval and final flushes: if the
           page died, no handler runs and nothing restores (safe); if the page
           survived a tab-hide, a failed keepalive post restores its seconds
           exactly like an interval one (verifier fix 2026-08-20). The body's
           stored count matters too — the worker can 200 with stored:0 when
           storage itself failed, and trusting the status alone would disarm
           every retry. */
        fetch(API + '/engage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ events: evs, t: tok }),
            keepalive: !!final
        }).then(function (r) {
            if (!r.ok) {
                restore(evs);
                if (r.status === 401) { tok = ''; warmToken(); }
                return;
            }
            return r.json().then(function (j) {
                if (j && j.stored === 0 && evs.length > 0) restore(evs);
                else markSent(evs);
            }).catch(function () { markSent(evs); });
        }).catch(function () { restore(evs); });
    }
    function flush(final) {
        var evs = events();
        if (!evs.length) return;
        if (final) {
            if (tok) { reset(); post(evs, true); }
            return; /* no warm token at teardown: keep accumulating, the
                       interval flush or next page will carry it */
        }
        if (tok) { reset(); post(evs, false); warmToken(); return; }
        /* cold-token path: reset NOW so seconds accruing during the token
           fetch land in the next flush instead of being zeroed, and restore
           the snapshot if no token arrives (verifier fix 2026-08-20) */
        reset();
        fetch('/members/api/session', { credentials: 'include' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (t) {
                if (!t) { restore(evs); return; }
                tok = t; post(evs, false);
            }).catch(function () { restore(evs); });
    }
    setInterval(function () { flush(false); }, 45000);
    document.addEventListener('visibilitychange', function () { if (document.hidden) flush(true); });
    window.addEventListener('pagehide', function () { flush(true); });
}
})();
}catch(e){ if (window.console) console.log('pc-engage', e && e.message); }
